class AdpComponentsListController {
  constructor() {
    this.name = 'adpComponentsList';
  }
}

export default AdpComponentsListController;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentsList/adpComponentsList.controller.js